<template>
  <Transition name="fade">
    <div
      v-if="isVisible"
      class="z-50 mx-2"
      role="alert"
      :aria-live="type === 'error' ? 'assertive' : 'polite'"
    >
      <div
        :class="[
          typeClasses,
          'shadow-toast w-fit m-auto text-white text-light px-4 py-3 rounded-md flex items-center space-x-3',
        ]"
      >
        <mdicon
          :name="typeIcon"
          :aria-label="type"
          size="24"
          aria-hidden="true"
        />
        <span :class="{ 'sr-only': !message }">{{ message }}</span>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'

const props = defineProps({
  message: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: 'success',
    validator: (value) => ['success', 'error', 'warning'].includes(value),
  },
  duration: {
    type: Number,
    default: 3000,
  },
})

const isVisible = ref(true)

const typeClasses = computed({
  get() {
    switch (props.type) {
      case 'error':
        return 'bg-red-1'
      case 'warning':
        return 'bg-amber-2'
      case 'success':
      default:
        return 'bg-black'
    }
  },
})

const typeIcon = computed({
  get() {
    switch (props.type) {
      case 'error':
        return 'close-circle-outline'
      case 'warning':
        return 'alert-circle-outline'
      case 'success':
      default:
        return 'check-circle-outline'
    }
  },
})

onMounted(() => {
  setTimeout(() => {
    isVisible.value = false
  }, props.duration)
})
</script>
